export const companyTypes = [
  { label: "CD", value: "CD" },
  { label: "Escritório", value: "Escritório" },
  { label: "Fábrica", value: "Fábrica" },
];
